// US-only launch (ABsmartly audience country=US) — copy is hardcoded EN.
import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		female: {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_paywall_price_anchor~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_paywall_price_anchor/female/__b'),
			},
		},
		'female-water-fasting': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female-water-fasting&exp=web_paywall_price_anchor~1
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_paywall_price_anchor/female-water-fasting/__b'),
			},
		},
		'activity-female-tai-chi-walking-pr': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-pr&exp=web_paywall_price_anchor~1
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_paywall_price_anchor/activity-female-tai-chi-walking-pr/__b'),
			},
		},
		'activity-female-tai-chi-walking-v2-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2-al&exp=web_paywall_price_anchor~1
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_paywall_price_anchor/activity-female-tai-chi-walking-v2-al/__b'),
			},
		},
		'activity-male-chair-tai-chi': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-chair-tai-chi&exp=web_paywall_price_anchor~1
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_paywall_price_anchor/activity-male-chair-tai-chi/__b'),
			},
		},
	},
]

export default config
